/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': '戻る',
  'ai-floating-context-menu.ai-dynamic-surface.close': '閉じる',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': '参照',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'アクション',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': '会話のきっかけを読み込み中...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Rovo に質問する',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'フィードバックを送信',
  'ai-smart-button.ai-actions.help.section.text': 'ヘルプ',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'リンク',
  'ai-smart-button.ai-actions.input.mention-button-label': 'メンション',
  'ai-smart-button.ai-actions.input.placeholder': 'ご用件を入力してください',
  'ai-smart-button.ai-actions.input.send-button-label': '送信',
  'ai-smart-button.ai-actions.item.betaLozenge': 'ベータ版',
  'ai-smart-button.ai-actions.item.newLozenge': 'NEW',
  'ai-smart-button.ai-actions.no-results-heading': 'Rovo に質問する',
  'ai-smart-button.ai-actions.no-results-text': 'Rovo にプロンプトを送信してチャットを開始しましょう。',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'アイコンを追加',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'エージェント アイコン',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': '自動化アイコン',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': '自動化',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'エージェントを見る',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'エージェントを作成',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': '自動化を作成',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'スタジオ',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'Rovo エージェントとは何ですか?',
  'ai-smart-button.ai-actions.static-agent-fallback-2':
    'Confluence スペースで Rovo エージェントを使用するにはどうすればよいですか?',
  'ai-smart-button.ai-actions.static-fallback-1': 'Rovo チャットとは何ですか?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Rovo チャットの使い方を教えてください',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'どのようなサポートをご希望ですか?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': '{name} さん',
  'ai-smart-button.ai-proactive-nudge.dismiss': '閉じる',
  'ai-smart-button.feedback-action.ask-question-option': '質問する',
  'ai-smart-button.feedback-action.can-contact-message':
    'アトラシアンの製品とサービスの向上のために、{product} のチームから利用体験に関する問い合わせを受け取ることを了承し、{privacyPolicy}に同意します。',
  'ai-smart-button.feedback-action.can-contact-message-appify':
    'はい、アトラシアンのアプリとサービスの向上のために、{product} のチームから利用体験に関する問い合わせを受け取ることを了承します。{privacyPolicy}に同意します',
  'ai-smart-button.feedback-action.cancel-button-label': 'キャンセル',
  'ai-smart-button.feedback-action.choose-feedback-option': '1 つ選択してください',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'バグや問題の内容をご入力ください',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': '具体的な内容をご入力ください',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'ご質問の内容をご入力ください',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': '改良を希望する点をご入力ください',
  'ai-smart-button.feedback-action.leave-comment-option': 'コメントを残す',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product} のプライバシー ポリシー。',
  'ai-smart-button.feedback-action.report-bug-option': 'バグを報告する',
  'ai-smart-button.feedback-action.research-participation-message': '製品調査に参加します',
  'ai-smart-button.feedback-action.select-feedback-heading': 'フィードバックの種類を選択してください',
  'ai-smart-button.feedback-action.submit-button-label': 'フィードバックを送信',
  'ai-smart-button.feedback-action.suggest-improvement-option': '改良点を提案する',
  'ai-smart-button.feedback-action.title': 'フィードバックを送信',
  'ai-smart-button.feedback-item.icon-label': 'フィードバック アイコン',
  'ai-smart-button.reference.close-button-label': '閉じる',
  'ai-smart-button.tooltip.label': 'Rovo AI に質問',
  'quick-summary.feedback.summary.placeholder': 'Atlassian Intelligence の良かった点と改善が必要な点はありますか?',
  'quick-summary.feedback.title': 'Atlassian Intelligence の改善にご協力ください',
};
